import { Pipe, PipeTransform } from '@angular/core';
import { DocumentTypeEnum } from '@domain';

@Pipe({
    name: 'iconByDocumentType',
    standalone: true,
})
export class IconByDocumentTypePipe implements PipeTransform {
    /**
     * Formata o ícone de acordo com o tipo de documento
     * @param type Tipo de documento
     * @returns Ícone do tipo, ou o ícone de documento normal se não houver tipo
     */
    transform(type: DocumentTypeEnum | null | undefined): string {
        switch (type) {
            case DocumentTypeEnum.QUOTE:
                return 'dollar-circle';
            case DocumentTypeEnum.CONTRACT:
                return 'pen-draw';
            default:
                return 'file';
        }
    }
}
